<template>
    <div class="UserMenuWrapper">
      <span class="userName">{{ userName }}</span>
      <a class="dropdown-toggle userMenuLink" href="#" id="userMenuDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <svg fill="#000000" height="15px" width="15px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve">
          <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
        </svg>
      </a>
      <ul class="dropdown-menu">
      <div class="wrapper" >
        <li><a @click="logout" class="dropdown-item">Logga ut</a> </li>
      </div>
    </ul>
    <div class="menuShortNameWrapper">
      <span class="shortName">{{shortName}}</span>
    </div>
      <!--<img class="userImage" src="@/assets/img/marie.png">-->
    </div>
</template>

<script>
import { bus } from '@/main'
export default {
  name: 'TopMenu',
  data () {
    return {
      userName: '',
      shortName: ''
    }
  },
  created () {
    this.userName = localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName')
    this.shortName = localStorage.getItem('firstName').substring(0, 1) + localStorage.getItem('lastName').substring(0, 1)
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          bus.$emit('loggedIn', false)
          this.$router.push('/')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menus/UserMenu.vue